import {
    getMeta,
    getMetaBool,
    getMetaNumber,
    getMetaIn,
} from '@precon-tools-suite-by-shared/browser-utils';
import { PartialPreconClientSettings } from './merge-settings';
import { DeploymentEnvironment } from './settings-types';

export function getClientSettingsFromMetaTags(): PartialPreconClientSettings {
    return {
        app: {
            name: getMeta('app-name'),
            instrumentationKey: getMeta('instrumentation-key'),
        },
        backend: {
            timezone: getMeta('backend-timezone'),
        },
        msal: {
            authority: getMeta('msal-authority'),
            knownAuthorities: getMeta('msal-known-authorities')?.split(' '),
            tenantId: getMeta('msal-tenant-id'),
            clientId: getMeta('app-client-id'),
        },
        graphql: {
            batch: {
                enabled: getMetaBool('graphql-batch-enabled'),
                debounce: getMetaBool('graphql-batch-debounce'),
                interval: getMetaNumber('graphql-batch-interval'),
                max: getMetaNumber('graphql-batch-interval'),
            },
            subscriptionAuthEndpoint: getMeta(
                'graphql-subscription-auth-endpoint'
            ),
            subscriptionsVia: getMetaIn('graphql-subscription-protocol', [
                'graphql-transport-ws',
                'pusher',
                'http',
                'ignore',
            ]),
            httpEndpoint: getMeta('graphql-http-endpoint'),
            wsEndpoint: getMeta('graphql-ws-endpoint'),
            logErrors: getMetaBool('graphql-log-errors'),
            logRoundTrip: getMetaBool('graphql-log-round-trip'),
            logWsEvents: getMetaBool('graphql-log-ws-events'),
        },
        environment: getMetaIn<DeploymentEnvironment>('app-environment', [
            'development',
            'local',
            'staging',
            'testing',
            'production',
        ]),
        importapi: {
            endpoint: getMeta('importapi-http-endpoint'),
        },
        pusher: {
            key: getMeta('graphql-pusher-key'),
            options: {
                cluster: getMeta('graphql-pusher-cluster'),
                disableStats: getMetaBool('graphql-pusher-disable-stats'),
                enableTransports: getMeta(
                    'graphql-pusher-enable-transports'
                )?.split(' '),
                forceTLS: getMetaBool('graphql-pusher-force-tls'),
                httpHost: getMeta('graphql-pusher-http-host'),
                httpPort: getMetaNumber('graphql-pusher-http-port'),
                httpsPort: getMetaNumber('graphql-pusher-https-port'),
                wsHost: getMeta('graphql-pusher-ws-host'),
                wsPort: getMetaNumber('graphql-pusher-ws-port'),
                wssPort: getMetaNumber('graphql-pusher-wss-port'),
            },
        },
    };
}
